<template>
  <b-container class="pt-0">
    <div class="toggle-types mb-4 pt-0">
      <div
        class="toggle-container"
        v-b-tooltip.v-secondary.hover.right="
          $t('reusable.sentenceContainer.insertOrCreateTooltip')
        "
      >
        <span :class="{ 'font-weight-bold': !checked }">{{
          $t("reusable.sentenceContainer.insert")
        }}</span>
        <b-button class="check-type" @click="changeChecked()" variant="primary">
          <b-icon
            icon="circle-fill"
            class="icon-check"
            :class="{ 'icon-check-active': checked }"
            scale="0.7"
          ></b-icon>
        </b-button>
        <span :class="{ 'font-weight-bold': checked }">{{
          $t("reusable.common.create")
        }}</span>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-body>
            <b-icon
              :id="`comment-action-${unique_id}`"
              class="float-right"
              style="cursor: pointer"
              icon="info-circle"
            ></b-icon>
            <div class="card-title ml-3">
              {{ first_title || $t("reusable.sentenceContainer.action") }}
            </div>
            <p class="card-text text-center">
              ({{ first_body || $t("reusable.sentenceContainer.verb") }})
            </p>
          </b-card-body>
        </b-card>
        <b-popover
          :target="`comment-action-${unique_id}`"
          placement="bottom"
          :title="$t('reusable.sentenceContainer.information')"
          triggers="hover focus"
        >
          <template v-slot:title></template>
          <div>
            <ul>
              <li>
                <p>
                  <strong>{{
                    $t("reusable.sentenceContainer.whatDoes")
                  }}</strong>
                  ({{ $getVisibleNames("mesh.verb", false, "Verbo") }}):
                  <strong>{{
                    $t("reusable.sentenceContainer.whatWillKnow")
                  }}</strong>
                </p>
              </li>
              <li>
                <p>
                  {{ $t("reusable.sentenceContainer.actionToPerform") }}
                  <strong>{{ $t("reusable.sentenceContainer.perform") }}</strong
                  >.
                </p>
              </li>
              <li>
                <p>
                  {{ $t("reusable.sentenceContainer.expressedIn") }}
                  <strong>{{
                    $t("reusable.sentenceContainer.indicative")
                  }}</strong>
                  {{ $t("reusable.sentenceContainer.indicativeExample") }}.
                </p>
              </li>
              <li>
                <p>
                  {{ $t("reusable.sentenceContainer.reflectsAction") }}
                  <strong>{{
                    $t("reusable.sentenceContainer.assessableAction")
                  }}</strong>
                  {{ $t("reusable.sentenceContainer.observableAction") }}.
                </p>
              </li>
            </ul>
          </div>
        </b-popover>
      </b-col>
      <!-- <b-col cols="1" style="vertical-align: middle">
        <unicon name="plus" fill="black" width="35" height="35"></unicon>
      </b-col> -->
      <b-col>
        <b-card no-body>
          <b-card-body>
            <b-icon
              :id="`comment-content-${unique_id}`"
              class="float-right"
              style="cursor: pointer"
              icon="info-circle"
            ></b-icon>
            <div class="card-title ml-3">
              {{ second_title || $t("reusable.sentenceContainer.object") }}
            </div>
            <p class="card-text text-center">
              ({{ second_body || $t("reusable.sentenceContainer.content") }})
            </p>
          </b-card-body>
        </b-card>
        <b-popover
          :target="`comment-content-${unique_id}`"
          placement="bottom"
          :title="$t('reusable.sentenceContainer.information')"
          triggers="hover focus"
        >
          <template v-slot:title></template>
          <div>
            <ul>
              <li>
                <p>
                  <strong>{{
                    $t("reusable.sentenceContainer.aboutWhat")
                  }}</strong>
                  {{ $t("reusable.sentenceContainer.aboutWhatPerforms") }}.
                </p>
              </li>
              <li>
                <p style="font-style: italic">
                  <strong>{{
                    $t("reusable.sentenceContainer.whatToEvaluate")
                  }}</strong>
                </p>
              </li>
            </ul>
          </div>
        </b-popover>
      </b-col>
      <!-- <b-col cols="1" style="vertical-align: middle">
        <unicon name="plus" fill="black" width="35" height="35"></unicon>
      </b-col> -->
      <b-col>
        <b-card no-body>
          <b-card-body>
            <b-icon
              :id="`comment-condition-${unique_id}`"
              class="float-right"
              style="cursor: pointer"
              icon="info-circle"
            ></b-icon>
            <div class="card-title ml-3">
              {{ third_title || $t("reusable.sentenceContainer.condition") }}
            </div>
            <p class="card-text text-center">
              ({{ third_body || $t("reusable.sentenceContainer.context") }})
            </p>
          </b-card-body>
        </b-card>
        <b-popover
          :target="`comment-condition-${unique_id}`"
          placement="bottom"
          :title="$t('reusable.sentenceContainer.information')"
          triggers="hover focus"
        >
          <template v-slot:title></template>
          <div>
            <ul>
              <li>
                <p>
                  <strong>{{
                    $t("reusable.sentenceContainer.forWhat")
                  }}</strong>
                </p>
              </li>
              <li>
                <p>
                  <strong>{{
                    $t("reusable.sentenceContainer.inWhatContext")
                  }}</strong
                  >.
                </p>
              </li>
              <li>
                <p>
                  <strong>{{
                    $t("reusable.sentenceContainer.attitudes")
                  }}</strong
                  >.
                </p>
              </li>
              <li>
                <p style="font-style: italic">
                  <strong>{{
                    $t("reusable.sentenceContainer.whatMeans")
                  }}</strong>
                </p>
              </li>
              <li>
                <p style="font-style: italic">
                  {{ $t("reusable.sentenceContainer.consideredInRelation") }}.
                </p>
              </li>
            </ul>
          </div>
        </b-popover>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!-- <label :for="`taxonomy_select-${unique_id}`">Taxonomía</label> -->
        <div
          v-if="taxonomies.length > 1"
          class="d-flex align-items-center justify-content-center"
        >
          <span class="taxonomy-toggle-label">
            {{
              selected_taxonomy != null && taxonomies[selected_taxonomy]
                ? taxonomies[selected_taxonomy].name
                : $getVisibleNames("mesh.taxonomy", true, "Taxonomías")
            }}
          </span>
          <span v-b-toggle.collapse-1 class="mb-0">
            <ButtonSmall
              v-if="!is_collapsed"
              :tooltip_text="`${$t('reusable.common.show')} ${$getVisibleNames(
                'mesh.taxonomy',
                false,
                'Taxonomía'
              )}`"
              :click_button="toggleCollapse"
              :custom_class="``"
              :icon="'chevron-down'"
            ></ButtonSmall>
            <ButtonSmall
              v-else
              :tooltip_text="`${$t('reusable.common.hide')} ${$getVisibleNames(
                'mesh.taxonomy',
                false,
                'Taxonomía'
              )}`"
              :click_button="toggleCollapse"
              :custom_class="``"
              :icon="'chevron-up'"
            ></ButtonSmall>
          </span>
        </div>
        <b-collapse id="collapse-1" class="mt-2 mb-3">
          <b-form-select
            v-model="selected_taxonomy"
            class="mb-1"
            :id="`taxonomy_select-${unique_id}`"
            :required="true"
            size="sm"
            :disabled="!allows_crud"
          >
            <option :value="null" selected>
              {{ $t("reusable.sentenceContainer.selectTaxonomy") }}
            </option>
            <option
              v-for="(taxonomy, index) in taxonomies"
              :key="taxonomy.id"
              :value="index"
            >
              {{ taxonomy.name }}
            </option>
          </b-form-select>
        </b-collapse>
        <div class="container-verb">
          <div
            class="wrapper"
            v-if="selected_taxonomy >= 0 && taxonomies[selected_taxonomy]"
          >
            <label
              :for="`multiselect_verbs-${unique_id}`"
              style="margin-bottom: -3%"
              >{{ $getVisibleNames("mesh.verb", true, "Verbos") }}</label
            >
            <!-- <multiselect
            :id="`multiselect_verbs-${unique_id}`"
            v-model="selected_verb"
            :options="getVerbs"
            :placeholder="
              selected_verb
                ? selected_verb.name
                : firstContent
                ? firstContent
                : 'Seleccione un verbo'
            "
            label="name"
            :custom-label="customLabel"
            track-by="name"
            size="sm"
            :disabled="!allows_crud"
          ></multiselect> -->

            <!-- :placeholder="
                selected_verb
                  ? selected_verb.name
                  : firstContent
                  ? firstContent
                  : 'Seleccione un verbo'
              " -->
            <v-select
              :id="`multiselect_verbs-${unique_id}`"
              v-model="selected_verb"
              :options="getVerbs"
              :reduce="(getVerbs) => getVerbs.id"
              label="name"
              track-by="id"
              size="sm"
              :disabled="!allows_crud"
              @option:selected="selectedVerb"
              @option:deselecting="removeVerb"
              v-b-tooltip.hover.v-secondary="
                selected_verb ? getCognitiveLevel : ''
              "
            >
              <template v-slot:option="option">
                <span>{{ option.cognitive_level }}. </span>
                {{ option.name }}
              </template>
              <template slot="selected-option" slot-scope="option">
                <span
                  v-b-tooltip.v-secondary="
                    `${$getVisibleNames(
                      'mesh.cognitivelevel',
                      false,
                      'Nivel Cognitivo'
                    )}`
                  "
                  >{{ option.cognitive_level }}.
                </span>
                {{ option.name }}
              </template>
              <template slot="no-options">
                <span>{{ $t("reusable.sentenceContainer.noVerbsMatch") }}</span>
              </template>
            </v-select>
            <!-- <b-form-text
              v-if="!selected_verb && allows_crud && !alternative_verb2"
              style="color: #dc3545 !important"
              >Este campo es obligatorio.</b-form-text
            > -->
          </div>

          <div class="row mt-1 alter-verb-div">
            <label
              class="alternative-verb-label text-center mb-1"
              :for="`alternative_verb-${unique_id}`"
              >{{ $t("reusable.sentenceContainer.customizeVerb") }}
              {{ $getVisibleNames("mesh.verb", false, "Verbo") }}</label
            >
            <div
              class="alternative-verb"
              style="display: block; margin-top: -2%; margin-right: 5%"
            >
              <b-form-group>
                <b-input-group class="w-100">
                  <!-- <b-input-group-append>
                    <b-input-group-text
                      class="
                        alter-verb-input-append
                        bg-transparent
                        border-right-0
                        mt-2
                        ml-3
                        pr-0
                      "
                    >
                      {{ alternative_verb1 }}
                    </b-input-group-text>
                  </b-input-group-append> -->
                  <b-form-input
                    :id="`alternative_verb-${unique_id} `"
                    class="alter-verb-input pl-2"
                    :disabled="!allows_crud"
                    v-model="alternative_verb2"
                    @update="fillSelectedVerb"
                  >
                  </b-form-input>
                  <b-tooltip
                    v-if="!this.selected_verb"
                    :id="`alter-verb-tooltip-${unique_id} `"
                    :target="`alternative_verb-${unique_id} `"
                    :show="!this.selected_verb && full_sentence_changed"
                    variant="secondary"
                    triggers="focus"
                    placement="bottom"
                    class="mb-2"
                  >
                    {{ $t("reusable.sentenceContainer.verbSavedWithoutLevel") }}
                  </b-tooltip>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </b-col>
      <!-- <b-col></b-col> -->
      <b-col v-if="!checked" cols="8">
        <b-form-textarea
          class="textarea mt-1"
          v-model="fullSentence"
          :state="fullSentenceState"
          aria-describedby="input-full-sentence-feedback"
          :rows="5"
          :disabled="!allows_crud"
        ></b-form-textarea>
        <b-form-invalid-feedback id="input-full-sentence-feedback">{{
          $t("reusable.common.required")
        }}</b-form-invalid-feedback>
      </b-col>
      <b-col v-if="checked">
        <b-form-textarea
          class="textarea mt-1"
          v-model="secondContent"
          :state="secondContentState"
          aria-describedby="input-second-feedback"
          :rows="5"
          :disabled="!allows_crud"
        ></b-form-textarea>
        <b-form-invalid-feedback id="input-second-feedback">{{
          $t("reusable.common.required")
        }}</b-form-invalid-feedback>
      </b-col>
      <!-- <b-col></b-col> -->
      <b-col v-if="checked">
        <b-form-textarea
          class="textarea mt-1"
          v-model="thirdContent"
          :state="thirdContentState"
          aria-describedby="input-third-feedback"
          :rows="5"
          :disabled="!allows_crud"
        ></b-form-textarea>
        <b-form-invalid-feedback id="input-third-feedback">{{
          $t("reusable.common.required")
        }}</b-form-invalid-feedback>
        <b-form-text style="margin: 0; padding: 0">{{
          third_content_comment ||
          $t("reusable.sentenceContainer.recommendGenericCompetence")
        }}</b-form-text>
      </b-col>
    </b-row>
    <!-- <b-row v-if="validateSentence">
      <b-col colspan="5">
        <p v-for="error in errors" :key="error">
          <span style="color: red; font-size: 8pt">{{ error }}</span>
        </p>
      </b-col>
    </b-row> -->
    <b-row v-if="errors.length == 0">
      <p style="text-align: center" class="w-100" v-if="checked">
        <span style="color: var(--kl-color-primary); font-weight: 600">{{
          firstContent + " "
        }}</span>
        <span style="color: var(--kl-text-muted)">{{ secondContent }}</span>
        <span style="color: var(--kl-text-heading)">{{
          " " + thirdContent
        }}</span>
      </p>
      <p style="text-align: center" class="w-100" v-else>
        <span style="color: var(--kl-color-primary); font-weight: 600">{{
          firstContent + " "
        }}</span>
        <span style="color: var(--kl-text-muted)">{{
          full_sentence
            ? full_sentence
                .trim()
                .substr(full_sentence.trim().indexOf(" ") + 1)
                .trim() == full_sentence.trim().split(" ").shift()
              ? ""
              : full_sentence
                  .trim()
                  .substr(full_sentence.trim().indexOf(" ") + 1)
                  .trim()
            : ""
        }}</span>
      </p>
    </b-row>
  </b-container>
</template>

<script>
// import Multiselect from "vue-multiselect";
// import "vue-multiselect/dist/vue-multiselect.min.css";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { generateUniqueId } from "@/utils/utils";

export default {
  name: "SentenceForm",
  components: {
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    // Multiselect,
    vSelect,
  },
  props: {
    first_title: {
      type: String,
      default: "", //Acción
    },
    second_title: {
      type: String,
      default: "", //Objeto
    },
    third_title: {
      type: String,
      default: "", //Condición
    },
    first_body: {
      type: String,
      default: "", //Verbo
    },
    second_body: {
      type: String,
      default: "", //Contenido
    },
    third_body: {
      type: String,
      default: "", //Contexto
    },
    first_content: {
      type: String,
      default: "",
    },
    second_content: {
      type: String,
      default: "",
    },
    third_content: {
      type: String,
      default: "",
    },
    full_sentence: {
      type: String,
      default: "",
    },
    third_content_comment: {
      type: String,
      default: "", //Se recomienda responder a una Competencia Genérica.
    },
    allows_crud: {
      type: Boolean,
      default: true,
    },
    verb: {
      type: Number,
      default: null,
    },
    is_required: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected_taxonomy: 0,
      selected_verb: this.verb ? this.verb : null,
      // alternative_verb1: this.first_content
      //   ? this.first_content.substr(0, 2)
      //   : "",
      alternative_verb2: this.first_content ? this.first_content : "",
      taxonomies: [],
      firstContent: this.first_content ? this.first_content : "",
      secondContent: this.second_content ? this.second_content : "",
      thirdContent: this.third_content ? this.third_content : "",
      unique_id: generateUniqueId(),
      errors: [],
      is_collapsed: false,
      checked: this.inferChecked(),
      fullSentence: this.full_sentence ? this.full_sentence : "",
      full_sentence_changed: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    getVerbs() {
      let verbs = [];
      this.taxonomies[this.selected_taxonomy].cognitive_levels.forEach((cl) => {
        cl.verbs.forEach((v) => {
          verbs.push({
            cognitive_level: cl.level,
            id: v.id,
            name: v.name,
          });
        });
      });
      return verbs;
    },
    getCognitiveLevel() {
      let verb = "";
      this.taxonomies[this.selected_taxonomy].cognitive_levels.forEach((cl) => {
        if (cl.verbs.find((x) => x.id == this.selected_verb)) {
          verb =
            this.$t("reusable.sentenceContainer.cognitiveLevel") +
            " " +
            cl.level +
            ": " +
            cl.name +
            ".";
          return verb;
        }
      });
      return verb;
    },
    secondContentState() {
      if (!this.is_required) return null;
      return this.secondContent.length > 1 ? true : false;
    },
    fullSentenceState() {
      if (!this.is_required) return null;
      return this.fullSentence.length > 1 ? true : false;
    },
    thirdContentState() {
      if (!this.is_required) return null;
      return this.thirdContent.length > 1 ? true : false;
    },
  },
  methods: {
    inferChecked() {
      // Sin un flag persistido en el backend, el modo del toggle se infiere de
      // los datos guardados. Si no hay contenido NI condición, siempre es
      // "Insertar" (false). Si los hay, fue "Crear" solo cuando la oración
      // completa guardada coincide con la concatenación verbo+contenido+condición
      // (así la construye el formulario al guardar en modo "Crear"); si la
      // oración libre es distinta, el usuario guardó en modo "Insertar".
      if (!(this.second_content && this.third_content)) return false;
      const normalize = (text) => (text || "").replace(/\s+/g, " ").trim();
      const fullSentence = normalize(this.full_sentence);
      const createSentence = normalize(
        `${this.first_content} ${this.second_content} ${this.third_content}`
      );
      return fullSentence === "" || fullSentence === createSentence;
    },
    validateSentence() {
      this.errors = [];
      let error = true;
      if (!this.is_required) {
        this.$emit("validation", true);
        return true;
      }
      if (this.checked) {
        if (!this.firstContent || this.firstContent == "") {
          this.errors.push(
            this.$t("reusable.sentenceContainer.mustSelectVerb")
          );
          error = false;
        }
        if (!this.secondContent || this.secondContent == "") {
          this.errors.push(
            this.$t("reusable.sentenceContainer.contentCannotBeEmpty")
          );
          error = false;
        }
        if (!this.thirdContent || this.thirdContent == "") {
          this.errors.push(
            this.$t("reusable.sentenceContainer.conditionCannotBeEmpty")
          );
          error = false;
        }
      } else {
        if (!this.fullSentence || this.fullSentence == "") {
          this.errors.push(
            this.$t("reusable.sentenceContainer.contentCannotBeEmpty")
          );
          error = false;
        }
      }
      this.$emit("validation", error);
      return error;
    },
    changeChecked() {
      this.checked = !this.checked;
      this.saveVerb();
      if (
        !(
          this.verb ||
          this.first_content ||
          this.second_content ||
          this.third_content ||
          this.full_sentence
        )
      ) {
        if (this.user && this.user.user_data) {
          this.$restful
            .Patch(`/authentication/user-data/${this.user.user_data.id}/`, {
              base_sentence_create: this.checked,
            })
            .then((resposne) => {
              this.user.user_data = resposne;
              this.$store.commit("setUser", this.user);
            });
        } else {
          this.$restful
            .Post(`/authentication/user-data/`, {
              user: this.user.id,
              identifier_type: null,
              address: null,
              identifier: "",
              phone_1: "",
              phone_2: "",
              alternative_email: "",
              font_size: 20,
              creation_email_sent: false,
              image: null,
              base_sentence_create: this.checked,
            })
            .then((resposne) => {
              this.user.user_data = resposne;
              this.$store.commit("setUser", this.user);
            });
        }
      }
    },
    selectedVerb(option) {
      // this.alternative_verb1 = option.name.substr(0, 2);
      // this.alternative_verb2 = option.name.substr(2);
      this.alternative_verb2 = option.name;
    },
    removeVerb() {
      // this.alternative_verb1 = "";
      this.alternative_verb2 = "";
    },
    fillSelectedVerb(action) {
      const verb = this.getVerbs.find(
        (x) =>
          x.name
            .normalize("NFD")
            .replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, "$1$2")
            .normalize()
            .trim()
            .toLowerCase() ==
          action
            .normalize("NFD")
            .replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, "$1$2")
            .normalize()
            .trim()
            .toLowerCase()
      );
      if (verb) {
        this.selected_verb = verb.id;
      }
    },
    // customLabel(item) {
    //   let label = item.name;
    //   this.taxonomies[this.selected_taxonomy].cognitive_levels.forEach((cl) => {
    //     if (cl.id == item.cognitive_level) {
    //       label = item.name + ". Nivel " + cl.level;
    //       return label;
    //     }
    //   });
    //   return label;
    // },
    fetchTaxonomies() {
      this.$store.dispatch(names.FETCH_TAXONOMIES).then((response) => {
        this.taxonomies = response;
        if (this.taxonomies.length == 1) this.selected_taxonomy = 0;
        this.taxonomies.forEach((t, index) => {
          if (t.active) this.selected_taxonomy = index;
        });
        this.findVerb();
      });
    },
    findVerb() {
      this.taxonomies.forEach((t, index) => {
        t.cognitive_levels.forEach((cl) => {
          cl.verbs.forEach((v) => {
            if (v.id == this.verb) {
              this.selected_verb = v.id;
              this.selected_taxonomy = index;
              if (v.name != this.first_content) {
                // this.alternative_verb1 = this.first_content.substr(0, 2);
                this.alternative_verb2 = this.first_content;
              }
            }
          });
        });
      });
    },
    saveVerb() {
      this.$emit("update", {
        verb: this.selected_verb ? this.selected_verb : null,
        // first_content: this.alternative_verb1.concat(this.alternative_verb2),
        first_content: !this.checked
          ? this.fullSentence.trim().split(" ").shift()
          : this.alternative_verb2,
        second_content: this.secondContent,
        third_content: this.thirdContent,
        full_sentence: this.fullSentence,
        base_sentence_toggle: this.checked,
      });
    },
    toggleCollapse() {
      return (this.is_collapsed = !this.is_collapsed);
    },
  },
  watch: {
    selected_taxonomy(newVal, oldVal) {
      if (newVal === oldVal || !this.selected_verb || !this.taxonomies[newVal])
        return;
      const verbExists = this.taxonomies[newVal].cognitive_levels.some((cl) =>
        cl.verbs.some(
          (v) =>
            v.name.trim().toLowerCase() ===
            this.alternative_verb2.trim().toLowerCase()
        )
      );
      if (!verbExists) {
        this.selected_verb = null;
        this.alternative_verb2 = "";
      } else {
        const matchingVerb = this.taxonomies[newVal].cognitive_levels
          .flatMap((cl) => cl.verbs)
          .find(
            (v) =>
              v.name.trim().toLowerCase() ===
              this.alternative_verb2.trim().toLowerCase()
          );
        if (matchingVerb) this.selected_verb = matchingVerb.id;
      }
    },
    selected_verb() {
      // if (!this.first_content && this.selected_verb) {
      //   this.firstContent = this.selected_verb.name;
      // }
      if (!this.checked) {
        this.fullSentence = this.fullSentence.replace(
          this.fullSentence.trim().split(" ").shift(),
          this.alternative_verb2
        );
        this.firstContent = this.alternative_verb2;
      }
      if (this.validateSentence()) {
        this.$emit("update", {
          verb: this.selected_verb ? this.selected_verb : null,
          // first_content: this.firstContent,
          first_content: !this.checked
            ? this.fullSentence.split(" ").shift()
            : this.firstContent,
          second_content: this.secondContent,
          third_content: this.thirdContent,
          full_sentence: this.fullSentence,
          base_sentence_toggle: this.checked,
        });
      }
    },
    alternative_verb2: {
      handler(item) {
        if (!this.allows_crud) return;
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.saveVerb(item);
        }, 200);
      },
      deep: true,
    },
    secondContent: function () {
      if (this.is_required) {
        if (this.validateSentence())
          this.$emit("update", {
            verb: this.selected_verb ? this.selected_verb : null,
            first_content: !this.checked
              ? this.fullSentence.trim().split(" ").shift()
              : this.firstContent,
            // first_content: this.firstContent,
            second_content: this.secondContent,
            third_content: this.thirdContent,
            full_sentence: this.fullSentence,
            base_sentence_toggle: this.checked,
          });
      } else {
        this.$emit("update", {
          verb: this.selected_verb ? this.selected_verb : null,
          first_content: !this.checked
            ? this.fullSentence.trim().split(" ").shift()
            : this.firstContent,
          second_content: this.secondContent,
          third_content: this.thirdContent,
          full_sentence: this.fullSentence,
          base_sentence_toggle: this.checked,
        });
      }
    },
    thirdContent: function () {
      if (this.is_required) {
        if (this.validateSentence()) {
          this.$emit("update", {
            verb: this.selected_verb ? this.selected_verb : null,
            // first_content: this.firstContent,
            first_content: !this.checked
              ? this.fullSentence.trim().split(" ").shift()
              : this.firstContent,
            second_content: this.secondContent,
            third_content: this.thirdContent,
            full_sentence: this.fullSentence,
            base_sentence_toggle: this.checked,
          });
        }
      } else {
        this.$emit("update", {
          verb: this.selected_verb ? this.selected_verb : null,
          first_content: !this.checked
            ? this.fullSentence.trim().split(" ").shift()
            : this.firstContent,
          second_content: this.secondContent,
          third_content: this.thirdContent,
          full_sentence: this.fullSentence,
          base_sentence_toggle: this.checked,
        });
      }
    },
    fullSentence: function () {
      if (this.is_required) {
        if (this.validateSentence()) {
          if (!this.checked) {
            this.alternative_verb2 = this.fullSentence
              .trim()
              .split(" ")
              .shift();
            this.fillSelectedVerb(this.alternative_verb2);
          }
          this.$emit("update", {
            verb: this.selected_verb ? this.selected_verb : null,
            // first_content: this.firstContent,
            first_content: !this.checked
              ? this.fullSentence.trim().split(" ").shift()
              : this.firstContent,
            second_content: this.secondContent,
            third_content: this.thirdContent,
            full_sentence: this.fullSentence,
            base_sentence_toggle: this.checked,
          });
        }
      } else {
        if (!this.checked) {
          this.alternative_verb2 = this.fullSentence.trim().split(" ").shift();
          this.fillSelectedVerb(this.alternative_verb2);
        }
        this.$emit("update", {
          verb: this.selected_verb ? this.selected_verb : null,
          first_content: !this.checked
            ? this.fullSentence.trim().split(" ").shift()
            : this.firstContent,
          second_content: this.secondContent,
          third_content: this.thirdContent,
          full_sentence: this.fullSentence,
          base_sentence_toggle: this.checked,
        });
      }
    },
    first_content() {
      this.firstContent = this.first_content;
    },
    second_content() {
      this.secondContent = this.second_content;
    },
    third_content() {
      this.thirdContent = this.third_content;
    },
  },
  mounted() {
    if (
      !(
        this.verb ||
        this.first_content ||
        this.second_content ||
        this.third_content ||
        this.full_sentence
      ) &&
      this.user &&
      this.user.user_data
    ) {
      this.checked = this.user.user_data.base_sentence_create;
    }

    // El formulario que contiene la oración valida según el modo, así que necesita saber
    // en cuál quedó: el que manda es el que se muestra acá, no el que él deduzca aparte
    this.$emit("mode", this.checked);
  },
  created() {
    this.fetchTaxonomies();
    this.validateSentence();
  },
};
</script>

<style scoped>
.card {
  /* Mismo esquema que los headers de tabla: celeste claro + texto azul. */
  background: var(--kl-table-header-bg);
  border: 1px solid var(--kl-card-border);
  border-radius: var(--kl-radius-lg);
  margin: 1px;
  color: var(--kl-table-header-text);
  text-align: center;
}
.card-title {
  text-decoration: underline;
  font-size: var(--kl-fs-caption);
  font-weight: var(--kl-fw-bold);
  margin-bottom: 0.25rem;
}
.card-body {
  padding: 0.6rem;
  font-size: var(--kl-fs-caption);
}
[class*="col"] {
  text-align: center;
  padding-right: 3px;
  padding-left: 3px;
}
.textarea {
  width: 100%;
  min-height: 150px;
  /* padding-left: 10px;
  padding-right: 10px; */
  text-align: justify;
  font-size: var(--kl-input-fs);
  color: var(--kl-text-body);
  border-radius: var(--kl-input-radius);
}
.collapse-icons {
  display: none;
}
#collapse-1 {
  z-index: 1;
  transition: 0.3s ease-out;
}
#collapse-1::after {
  display: none;
  transition: 0.3s;
}
.alternative-verb-label {
  margin-inline: auto;
  /* padding-bottom: 0.1em; */
  margin-top: 0.46rem;
  margin-bottom: 0;
  /* transform: translateY(20%); */
}
.alternative-verb {
  display: flex;
  width: 100%;
}

.alter-verb-input,
.alter-verb-input-append {
  max-height: 2.15em !important;
  margin-left: 0.9em;
  margin-right: 0.1em;
}
.alter-verb-input-append {
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
}
.container-verb {
  z-index: 100;
}
.toggle-container {
  width: 30%;
  margin-left: auto;
  margin-right: 0;
  padding-left: 1.4em;
}
.check-type {
  background: var(--kl-color-primary) !important;
  border-color: var(--kl-color-primary) !important;
  margin-inline: 0.7em;
  height: 1.1em;
  width: 2.2em !important;
  margin-top: 0;
  border-radius: var(--kl-radius-pill);
}
.icon-check {
  color: var(--kl-text-on-primary);
  transform: translate(-70%, -50%);
  transition: 0.2s;
}
.icon-check-active {
  transform: translate(15%, -50%) !important;
}
@media (min-width: 1400px) {
  .alter-verb-input {
    padding-bottom: 13px;
  }
}

@media (max-width: 991px) {
  .vs__dropdown-menu {
    z-index: 1000 !important;
  }
  .alter-verb-div {
    margin-top: -1% !important;
  }
  .alternative-verb-label {
    font-size: 11pt;
  }
  .alter-verb-input-append {
    margin-left: 40% !important;
  }
  .alter-verb-input {
    padding-bottom: 13px;
    margin-left: 8%;
    margin-right: 2%;
  }
  .container-verb {
    transform: translateY(-5%);
  }
  .verb-label {
    font-size: 11pt;
  }
  .btn-transparent {
    margin-top: -8%;
  }
  .textarea {
    z-index: 1 !important;
  }
  .toggle-container {
    width: 40%;
    padding-left: 1.6em;
  }
}
</style>